import { render } from "./Step2.vue?vue&type=template&id=63931bee"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"
script.render = render

export default script